module.exports = __webpack_public_path__ + "static/media/nissan-logo.1f8099d9.png";